@use "@inshared/ui-foundation/css/tokens/breakpoints";
@use "@inshared/ui-foundation/css/tokens/color";
@use "@inshared/ui-foundation/css/tokens/spacing";

web-chatbot-list {
    --left-gutter: 50px;
    @media (min-width: breakpoints.$screen-md-min) {
        --left-gutter: 90px;
    }

    .chatbot-list {
        padding: 20px;
        display: flex;
        flex-direction: column;
        gap: spacing.$xl;
    }

    .chatbot-item {
        color: color.$color-text-lighter;
    }
    .chatbot-answer-item {
        display: flex;
        align-items: center;
        min-height: 8rem;
        --aspect-ratio: calc(80 / 100);
        --width: calc(var(--left-gutter) - 10px);

        background: url("/assets/images/chat-shmuppet-80x100.png") no-repeat top left;
        background-size: var(--width) calc(var(--width) / var(--aspect-ratio));
        padding-left: var(--left-gutter);
        @media (min-width: breakpoints.$screen-md-min) {
            --width: calc(var(--left-gutter) - 20px);
            min-height: 9.5rem;
        }
    }
    .chatbot-question-item {
        @media (min-width: breakpoints.$screen-md-min) {
            padding-left: var(--left-gutter);
        }
    }
    .chatbot-balloon {
        background: color.$color-background-200;
        border-radius: 0.5rem;
        padding: spacing.$lg;
    }
    .web-balloon {
        min-width: 100%;
    }
}
